export default __webpack_public_path__ + "static/media/workizIcon.2568fd1f.svg";